export function normalizeNamePart(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}
